import React from "react";
import { useAuth } from "../context/AuthContext";
import CryptoCalculator from "../components/CryptoCalculator";
import logo from "../assets/walletven.png";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { useLocation } from "react-router-dom";


export default function DashboardPage() {
   const location = useLocation();
  const { user, logout } = useAuth();
 const presets = location.state || {};

  return (
    <>
      <Navbar/>
    <div className="dashboard canvas">

      <main className="dashboard-main">
          <CryptoCalculator
            presetSymbol={presets.presetSymbol}
            presetChain={presets.presetChain}
            presetAmount={presets.presetAmount}
          />
      </main>
    </div>
    </>

  );
}
